import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggle"]
  static values = {
    threshold: Number,
    triggerSelector: String
  }

  connect() {
    this.scrollHandler = this.handleScroll.bind(this);
    window.addEventListener("scroll", this.scrollHandler);
  }

  disconnect() {
    window.removeEventListener("scroll", this.scrollHandler);
  }

  handleScroll() {
    const shouldHide = this.shouldHide();

    if (shouldHide) {
      this.toggleTarget.classList.add("is-hidden");
    } else {
      this.toggleTarget.classList.remove("is-hidden");
    }
  }

  shouldHide() {
    const thresholdValue = this.hasThresholdValue ? this.thresholdValue : 1000;
    if (this.hasTriggerSelectorValue) {
      const triggerElement = document.querySelector(this.triggerSelectorValue);
      if (!triggerElement) return window.scrollY >= thresholdValue;

      const rect = triggerElement.getBoundingClientRect();
      return rect.top <= 0;
    } else {
      return window.scrollY >= thresholdValue;
    }
  }
}